import { minimatch } from 'minimatch';

export function matchAnyPattern(location: string, patternsStr: string): boolean {
  const patterns: string[] = patternsStr.split('\r\n');
  const excludePatterns = patterns.filter(p => p.startsWith('!')).map(p => p.replace('!', ''));
  const includePatterns = patterns.filter(p => !p.includes('!'));
  // /index should be replaced with / to match glob pattern / for root/homepage URLS
  const replacedLocation = location.replace('/index', '/');

  if (includePatterns.length === 0) includePatterns.push('/**/*');

  const match = includePatterns.some(p => minimatch(replacedLocation, p)) || false;
  const negateMatch = excludePatterns.some(p => minimatch(replacedLocation, p)) || false;

  return match && !negateMatch;
}
